// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.5_@rspack+core@2.2.8_webpack@5.111.1_esbuild@0.28.1_postcss@8.5.28_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.5_@rspack+core@2.2.8_webpack@5.111.1_esbuild@0.28.1_postcss@8.5.28_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Look Angles menu styles. The menu (and its settings secondary menu) opt into
 * the shared v13 card system (.kt-ui-v13 + kt-section/kt-field-row); see
 * src/engine/ui/menu-v13.css. Only the results-table chrome and the dense-form
 * fixes for the stacked settings fields need plugin-specific styling.
 */

/* ===== Results table (inside a v13 section card) ===== */
.la-table {
  width: 100%;
  margin: 4px 0 0;
  border-collapse: collapse;
  line-height: 1.4;
  font-size: 13px;
}

.la-table td {
  text-align: center;
  padding: 5px 4px;
  border-bottom: 1px solid var(--color-dark-border);
}

/* Header row (v13 uppercase-muted look; replaces the old per-cell underline) */
.la-table .la-table-header td {
  padding: 4px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--color-dark-text-muted);
  border-bottom: 1px solid var(--color-dark-border);
}

/* Clickable result rows */
.la-table tr.link {
  cursor: pointer;
  transition: background-color 0.15s ease;
}

.la-table tr.link:hover {
  background-color: rgba(255, 255, 255, 0.07);
}

/* ===== Settings secondary menu (dense form: switch + stacked fields) ===== */
.la-switch-row {
  margin: 4px 0 0;
}

/* 1. Stacked-field headroom: this card stacks the rise/set switch plus two
 *    labelled fields, so the floating "active" labels collide with the row
 *    above without extra top margin. */
#look-angles-menu-secondary .kt-field-row .input-field.col { margin-top: 20px; }
#look-angles-menu-secondary .kt-section-label + .kt-field-row .input-field.col { margin-top: 8px; }

/* 3. Focus indication: swap the app-wide :focus-visible outline (which overlaps
 *    the floating label) for KeepTrack's underline. */
#look-angles-menu-secondary .input-field input:focus {
  border-bottom-color: var(--color-primary) !important;
  box-shadow: 0 1px 0 0 var(--color-primary);
}

#look-angles-menu-secondary .input-field input:focus-visible { outline: none; }
`, "",{"version":3,"sources":["webpack://./src/plugins/sensor/look-angles.css"],"names":[],"mappings":"AAAA;;;;;EAKE;;AAEF,0DAA0D;AAC1D;EACE,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iDAAiD;AACnD;;AAEA,+EAA+E;AAC/E;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,mCAAmC;EACnC,iDAAiD;AACnD;;AAEA,0BAA0B;AAC1B;EACE,eAAe;EACf,uCAAuC;AACzC;;AAEA;EACE,2CAA2C;AAC7C;;AAEA,8EAA8E;AAC9E;EACE,eAAe;AACjB;;AAEA;;uCAEuC;AACvC,6DAA6D,gBAAgB,EAAE;AAC/E,iFAAiF,eAAe,EAAE;;AAElG;sDACsD;AACtD;EACE,oDAAoD;EACpD,0CAA0C;AAC5C;;AAEA,+DAA+D,aAAa,EAAE","sourcesContent":["/*\n * Look Angles menu styles. The menu (and its settings secondary menu) opt into\n * the shared v13 card system (.kt-ui-v13 + kt-section/kt-field-row); see\n * src/engine/ui/menu-v13.css. Only the results-table chrome and the dense-form\n * fixes for the stacked settings fields need plugin-specific styling.\n */\n\n/* ===== Results table (inside a v13 section card) ===== */\n.la-table {\n  width: 100%;\n  margin: 4px 0 0;\n  border-collapse: collapse;\n  line-height: 1.4;\n  font-size: 13px;\n}\n\n.la-table td {\n  text-align: center;\n  padding: 5px 4px;\n  border-bottom: 1px solid var(--color-dark-border);\n}\n\n/* Header row (v13 uppercase-muted look; replaces the old per-cell underline) */\n.la-table .la-table-header td {\n  padding: 4px;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: var(--color-dark-text-muted);\n  border-bottom: 1px solid var(--color-dark-border);\n}\n\n/* Clickable result rows */\n.la-table tr.link {\n  cursor: pointer;\n  transition: background-color 0.15s ease;\n}\n\n.la-table tr.link:hover {\n  background-color: rgba(255, 255, 255, 0.07);\n}\n\n/* ===== Settings secondary menu (dense form: switch + stacked fields) ===== */\n.la-switch-row {\n  margin: 4px 0 0;\n}\n\n/* 1. Stacked-field headroom: this card stacks the rise/set switch plus two\n *    labelled fields, so the floating \"active\" labels collide with the row\n *    above without extra top margin. */\n#look-angles-menu-secondary .kt-field-row .input-field.col { margin-top: 20px; }\n#look-angles-menu-secondary .kt-section-label + .kt-field-row .input-field.col { margin-top: 8px; }\n\n/* 3. Focus indication: swap the app-wide :focus-visible outline (which overlaps\n *    the floating label) for KeepTrack's underline. */\n#look-angles-menu-secondary .input-field input:focus {\n  border-bottom-color: var(--color-primary) !important;\n  box-shadow: 0 1px 0 0 var(--color-primary);\n}\n\n#look-angles-menu-secondary .input-field input:focus-visible { outline: none; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
